import { Box, IconButton, Typography } from '@mui/material';
import { LightTooltip } from 'lib/designSystem/WhiteTooltip';
import React from 'react';

interface InfoRowWithActionsProps {
  label: string;
  value?: string;
  icon: React.ReactElement;
  maxLength?: number;
  actions?: {
    onClick: React.MouseEventHandler<HTMLButtonElement>;
    icon: React.ReactElement;
    tooltipText?: string;
  }[];
}

const InfoRowWithActions: React.FC<InfoRowWithActionsProps> = ({
  label,
  value,
  icon,
  maxLength = 40,
  actions = [],
}) => {
  const displayValue = value ?? 'No hay información';
  const textToShow =
    displayValue.length > maxLength
      ? displayValue.slice(0, maxLength) + '...'
      : displayValue;

  return (
    <>
      <Box display="flex" alignItems="center" gap={1} sx={{ mb: 1.5 }}>
        <Box
          sx={{
            backgroundColor: value
              ? 'rgba(25, 118, 210, 0.1)'
              : 'rgba(158, 158, 158, 0.1)',
            borderRadius: '50%',
            p: 0.4,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: '24px',
            height: '24px',
          }}
        >
          {React.cloneElement(icon, {
            sx: {
              ...icon.props.sx,
              color: value
                ? icon.props.sx?.color || 'primary.main'
                : 'text.disabled',
            },
          })}
        </Box>
        <Box sx={{ flex: 1 }}>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ fontSize: '0.8rem', display: 'block', mb: 0.2 }}
          >
            {label}
          </Typography>
          <Typography
            variant="body2"
            sx={
              value
                ? {
                    fontSize: '0.9rem',
                    lineHeight: 1.2,
                  }
                : {
                    fontSize: '0.9rem',
                    lineHeight: 1.2,
                    color: 'text.disabled',
                    fontStyle: 'italic',
                  }
            }
          >
            {textToShow}
          </Typography>
        </Box>
        {actions.length > 0 && (
          <Box sx={{ display: 'flex', gap: 0 }}>
            {actions.map((action, index) => (
              <LightTooltip
                key={index}
                title={
                  <Typography padding={1}>{action.tooltipText}</Typography>
                }
              >
                <IconButton onClick={action.onClick}>{action.icon}</IconButton>
              </LightTooltip>
            ))}
          </Box>
        )}
      </Box>
    </>
  );
};

export default InfoRowWithActions;
